import { render, staticRenderFns } from "./VConfirmModal.vue?vue&type=template&id=45318fa4"
import script from "./VConfirmModal.vue?vue&type=script&lang=ts"
export * from "./VConfirmModal.vue?vue&type=script&lang=ts"
import style0 from "./VConfirmModal.vue?vue&type=style&index=0&id=45318fa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports